import styled from 'styled-components';

// import { ReactComponent as LoadingIcon } from '../../asset/loading.svg';

export const QRCodeLayout = styled.div<{
  size: number;
}>`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  //border: 1px solid #e5e5e5;
  width: ${(props: any) => `${props.size}`}px;
  height: ${(props: any) => `${props.size}`}px;
`;

export const Mask = styled.div<{
  hidden?: boolean;
}>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: ${(props: any) => (props.hidden ? 'none' : 'block')};
  background: #fff;
  clear: both;
  opacity: 0.9;
  user-select: none;
  pointer-events: none;
`;
export const Placeholder = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const Spin = styled.i`
  //TODO 暂时忽略SVG
  //font-size: 24px;
  //color: #269bff;
  //animation: loadingCircle 1s infinite linear;
`;
export const SpinText = styled.span`
  //position: absolute;
  //top: 50%;
  width: 100%;
  text-align: center;
  padding-top: 5px;
  text-shadow: 0 1px 2px #fff;
  color: #269bff;
`;
export const Button = styled.div``;
